export default __webpack_public_path__ + "static/media/Cloudera.99681d9e.png";